import { fluidRange } from 'polished';
import PropTypes from 'prop-types';
import styled from '@happymoneyinc/styled-components';
import ThemeWrapper from '../utils/ThemeWrapper/index.js';
import { jsx } from 'react/jsx-runtime';

const Paragraph = props => {
  const {
    children,
    className,
    colorTheme,
    fontFamily,
    lineHeight,
    muted,
    size,
    testID,
    weight
  } = props;
  return /*#__PURE__*/jsx(ThemeWrapper, {
    children: /*#__PURE__*/jsx(ParagraphBase, {
      className: `${className} ho-paragraph`,
      $colorTheme: colorTheme,
      "data-testid": testID,
      fontFamily: fontFamily,
      $lineHeight: lineHeight,
      muted: muted,
      size: size,
      weight: weight,
      children: children
    })
  });
};
const ParagraphBase = styled.p`
  ${_ref => {
  let {
    size,
    theme
  } = _ref;
  return fluidRange({
    prop: 'font-size',
    fromSize: `${theme.fontStyles.paragraphs[size].fontSizeMin}px`,
    toSize: `${theme.fontStyles.paragraphs[size].fontSizeMax}px`
  }, `${theme.screen.xxs}`, `${theme.screen.xl}`);
}}

  color: ${_ref2 => {
  let {
    $colorTheme,
    muted,
    theme
  } = _ref2;
  if ($colorTheme === 'light') return muted ? theme.colors.gray[2] : theme.colors.white;
  if ($colorTheme === 'error') return muted ? theme.colors.gray[1] : theme.colors.systemRed;
  return muted ? theme.colors.gray[2] : theme.colors.black;
}};
  font-family: ${_ref3 => {
  let {
    fontFamily,
    theme
  } = _ref3;
  return fontFamily === 'mabry' ? theme.fonts.MabryProRegular : theme.fonts.InterRegular;
}};
  -webkit-font-smoothing: antialiased;
  font-weight: ${_ref4 => {
  let {
    theme,
    weight
  } = _ref4;
  return theme.fontStyles.weights[weight];
}};
  line-height: ${_ref5 => {
  let {
    $lineHeight,
    size,
    theme
  } = _ref5;
  return theme.fontStyles.paragraphs[size].lineHeight[$lineHeight];
}};
`;
Paragraph.defaultProps = {
  children: null,
  className: '',
  colorTheme: 'default',
  fontFamily: 'inter',
  lineHeight: 'normal',
  muted: false,
  size: 'md',
  testID: 'paragraph',
  weight: 'regular'
};
Paragraph.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  colorTheme: PropTypes.oneOf(['default', 'light', 'error']),
  fontFamily: PropTypes.oneOf(['mabry', 'inter']),
  lineHeight: PropTypes.oneOf(['normal', 'large']),
  muted: PropTypes.bool,
  size: PropTypes.oneOf(['lg', 'md', 'sm', 'xs', 'xxs']),
  testID: PropTypes.string,
  weight: PropTypes.oneOf(['medium', 'regular'])
};
var Paragraph$1 = Paragraph;

export { Paragraph$1 as default };
//# sourceMappingURL=Paragraph.js.map
